import ApexToolbarIcon from './ApexToolbarIcon'

export default ApexToolbarIcon
